<template lang="pug">
  #app
    transition(name="quit")
      #loading(v-if="!isLoading")
        .loadContain(v-if="!isLoading")
          .line
          .line
          .line
    .wrap
      Bio
      Publication
      Portfolio
      .footer Copyright © 2024, By Yuan.C
</template>

<script>

import Bio from '@/section/Bio'
import Publication from '@/section/Publication'
import Portfolio from '@/section/Portfolio'

export default {
  name: 'app',
  components: {
    Bio,
    Publication,
    Portfolio
  },
  data () {
    return {
      isLoading: false
    }
  },
  created () {
    document.querySelector('html').style.overflow = 'hidden'
    let self = this
    window.onload = function () {
      self.isLoading = true
      document.querySelector('html').style.overflow = 'inherit'
      document.querySelector('.wrap').style.opacity = '1'
    }
  }
}
</script>

<style lang="sass">
@import "../node_modules/bulma/bulma"
html, body
  width: 100%
  height: 100%
  margin: 0
  padding: 0
#app
  width: 100%
  height: 100%
  .footer
    padding: 2rem 1.5rem
    background-color: rgba(#999, 0.2)
    font-size: .8em
    font-weight: 600
    color: #555
    text-align: center
#loading
  position: fixed
  overflow: hidden
  width: 100%
  height: 100%
  z-index: 1999
  background-color: #fff
  .loadContain
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    .line
      display: inline-block
      width: 15px
      height: 15px
      border-radius: 15px
      background-color: #444
      margin: 3px
    .line:nth-last-child(1)
      animation: loadingC .6s .1s linear infinite
    .line:nth-last-child(2)
      animation: loadingC .6s .2s linear infinite
    .line:nth-last-child(3)
      animation: loadingC .6s .3s linear infinite
@keyframes loadingC
    0
      transform: translate(0,0)
    50%
      transform: translate(0,15px)
    100%
      transform: translate(0,0)

.wrap
  opacity: 0
  transition: opacity 1s ease 1.2s

.quit-leave-active
  animation: leave 1.2s

@keyframes leave
  0%
    opacity: 1
  100%
    opacity: 0

</style>



// WEBPACK FOOTER //
// src/App.vue